module.exports = __webpack_public_path__ + "media/audio7.a5a6b86f.mp3";